import NameField from "components/onboarding/create/NameField";
import { validateUserCountry, validateUserFullname } from "./validators";
import countries from "@qoohoo/common/constants/country/countries";
import CountryField from "components/onboarding/create/CountryField";

export const welcomeFields = [
  {
    name: "user_fullname",
    type: "text",
    required: true,
    label: "What's your name?",
    placeholder: "Your name",
    validator: validateUserFullname,
    formatValue: (val) => val,
    component: NameField,
  },
  {
    name: "user_country",
    type: "dropdown",
    required: true,
    label: "Where do you live?",
    options: countries,
    validator: validateUserCountry,
    placeholder: "Country",
    formatValue: (val) => val,
    component: CountryField,
  },
];
